// extracted by mini-css-extract-plugin
export default {"tab_button":"DashboardTabButton_tab_button__eXjKu","button_name":"DashboardTabButton_button_name__8S48O","active":"DashboardTabButton_active__0pR1Y"};